import type { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react'
import './Button.css'

export type ButtonVariant = 'primary' | 'light'

export type ButtonProps<T extends ElementType = 'button'> = {
  variant?: ButtonVariant
  as?: T
  children: ReactNode
} & Omit<ComponentPropsWithoutRef<T>, 'as' | 'children'>

export function Button<T extends ElementType = 'button'>({
  variant = 'primary',
  as,
  children,
  className,
  ...rest
}: ButtonProps<T>) {
  const Component = (as || 'button') as ElementType
  const classes = ['azoya-button', `azoya-button--${variant}`, className]
    .filter(Boolean)
    .join(' ')
  return (
    <Component className={classes} {...rest}>
      {children}
    </Component>
  )
}
